export default class AzureSearchRequest {
  constructor(settings) {
    this.search = '*';
    this.select = null;
    this.filter = null;
    this.queryType = 'full';
    this.orderBy = null;
    this.top = null;
    this.skip = null;
    this.count = true;
    this.facets = [];
    this.highlight = null;
    this.highlightPreTag = null;
    this.highlightPostTag = null;
    this.scoringProfile = null;
    if (settings) {
      if (settings.search) this.search = settings.search;
      if (settings.select) this.select = settings.select;
      if (settings.filter) this.filter = settings.filter;
      if (settings.queryType) this.queryType = settings.queryType;
      if (settings.searchMode) this.searchMode = settings.searchMode;
      if (settings.orderBy) this.orderBy = settings.orderBy;
      if (settings.top !== undefined && settings.top !== null)
        { this.top = settings.top; };
      if (settings.skip !== undefined && settings.skip !== null)
        { this.skip = settings.skip; };
      if (settings.count !== undefined && settings.count !== null)
        { this.count = settings.count; };
      if (settings.facets) this.facets = settings.facets;
      if (settings.highlight) this.highlight = settings.highlight;
      if (settings.highlightPreTag)
        { this.highlightPreTag = settings.highlightPreTag; };
      if (settings.highlightPostTag)
        { this.highlightPostTag = settings.highlightPostTag; };
      if (settings.scoringProfile) this.scoringProfile = settings.scoringProfile;
    }
  }

	getSearchRequestBody() {
		const requestBody = {};
		if (this.queryType) requestBody.queryType = this.queryType;
		if (this.search) {
			// Controleer eerst of de zoekstring spaties bevat
			if (!this.search.includes(' ')) {
				// Als er geen spaties zijn, controleer dan of de zoekstring een nummer bevat
				if (this.containsNumber(this.search)) {
					requestBody.search = '/.*' + this.search + '.*/';
					requestBody.queryType = 'full'; // Stel queryType in op 'full' als er een nummer in de zoekstring staat zonder spaties
				} else {
					requestBody.search = this.search;
				}
			} else {
				requestBody.search = this.search; // Als er spaties zijn, blijft de zoekopdracht ongewijzigd
			}
		}
		if (this.select) requestBody.select = this.select;
		if (this.filter) requestBody.filter = this.filter;
		if (this.searchMode) requestBody.searchMode = this.searchMode;
		if (this.orderBy) requestBody.orderby = this.orderBy;
		if (this.top !== undefined && this.top !== null) requestBody.top = this.top;
		if (this.skip !== undefined && this.skip !== null) requestBody.skip = this.skip;
		if (this.count !== undefined && this.count !== null) requestBody.count = this.count;
		if (this.facets) requestBody.facets = this.facets;
		if (this.highlight) requestBody.highlight = this.highlight;
		if (this.highlightPreTag) requestBody.highlightPreTag = this.highlightPreTag;
		if (this.highlightPostTag) requestBody.highlightPostTag = this.highlightPostTag;
		if (this.scoringProfile) requestBody.scoringProfile = this.scoringProfile;
		return requestBody;
	}

	// Nieuwe functie om te controleren of de zoekstring een nummer bevat
	containsNumber(phrase) {
		return /\d/.test(phrase); // Gebruikt een reguliere expressie om te controleren op de aanwezigheid van een nummer
	}
}
